import Vue from 'vue'
import App from './App.vue'
import router from './router'
import axios from 'axios'
import VueAxios from 'vue-axios'
import VueSweetalert2 from "vue-sweetalert2";
import VueHtmlToPaper from 'vue-html-to-paper';


const options = {
    name: '_blank',
    specs: [
        'fullscreen=yes',
        'titlebar=yes',
        'scrollbars=no',
        'close=no'
    ],
    styles: [
        'https://farskala.ir/wp-content/plugins/woocommerce-invoice/assets/css/1.css',
        'http://amirtorkaman.ir/fk2.css'
    ]
}


Vue.use(VueSweetalert2)
Vue.use(VueAxios, axios)
Vue.use(VueHtmlToPaper, options);

import './assets/css/bootstrap.css'

//custom css
import './assets/css/styles.css'


Vue.prototype.$token = localStorage.getItem("token");
Vue.Can = [];


Vue.prototype.$header = {
    headers: {'Authorization': `Bearer ${Vue.prototype.$token}`}
};

Vue.prototype.$hostname = "https://farskala.ir/wp-json/app/";


Vue.config.productionTip = false
new Vue({
    render: h => h(App),
    router,
}).$mount('#app')
